export const createClassName = (condition) => (first, second) =>
  condition ? first : second;
